import {Injectable} from "@angular/core";
import {environment} from "../../../environments/environment";
import {HttpService} from "../http/http.service";
import {ApplyJobDto} from "../../contracts/apply-jobs/apply-job.dto";
import {ApplyJobFilter} from "../../contracts/apply-jobs/apply-job.filter";
import {DownloadService} from "../download.service";

@Injectable({providedIn: 'root'})
export class ApplyJobService {
  private base = environment.url + '/api/applyJob/';

  constructor(private http: HttpService,
              private downloadService: DownloadService) {
  }

  submit(form: ApplyJobDto) {
    return this.http.postFormData(this.base + 'submit', form);
  }

  getReport(filter: ApplyJobFilter) {
    return this.http.post<any>(this.base + 'getReport', filter);
  }

  async exportReport(filter: ApplyJobFilter) {
    const res = await this.http.postGetBlob(this.base + 'ExportReport', filter);
    if (res) {
      this.downloadService.downloadFromBlob(res.data, res.fileName);
    }
  }
}
